var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 77.297,
    height: 77.296,
    viewBox: "0 0 77.297 77.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 77.297,
    height: 77.296,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M77.3,38.649A38.648,38.648,0,1,1,38.648,0,38.65,38.65,0,0,1,77.3,38.649",
    transform: "translate(0.002 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M34.99,44.867H20.822a1.351,1.351,0,1,1,0-2.7h5.733V37.341H12.234a5.1,5.1,0,0,1-5.09-5.09V13.183a5.1,5.1,0,0,1,5.09-5.09H43.578a5.1,5.1,0,0,1,5.09,5.09V32.251a5.1,5.1,0,0,1-5.09,5.09H29.257v4.825H34.99a1.351,1.351,0,1,1,0,2.7M36.342,34.64h7.236a2.391,2.391,0,0,0,2.389-2.389V28.486H36.342Zm-8.437,0h5.736V28.486H23.022V34.64ZM9.845,28.486v3.766a2.391,2.391,0,0,0,2.389,2.389h8.087V28.486Zm26.5-2.7h9.624V20.056H36.342Zm-13.32,0H33.641V20.056H23.022Zm-13.177,0H20.321V20.056H9.845Zm26.5-8.43h9.624V13.183a2.391,2.391,0,0,0-2.389-2.389H36.342Zm-13.32,0H33.641v-6.56H23.022Zm-13.177,0H20.321v-6.56H12.234a2.391,2.391,0,0,0-2.389,2.389Z",
    transform: "translate(10.742 12.168)",
    fill: "#eaff50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryIcon);
export default __webpack_public_path__ + "static/media/battery_icon.6d6b1108dc1e89819ace2c7bb1356a8c.svg";
export { ForwardRef as ReactComponent };